export function recommendStakes(tips, profile) {
  const cap = Math.min(
    profile.budget === null ? Infinity : profile.budget * 0.1,
    profile.maxTotalStake ?? Infinity
  );
  const perTip = Math.min(
    profile.stake,
    profile.maxStake ?? Infinity,
    tips.length ? cap / tips.length : 0
  );
  const stake = Math.floor(perTip * 100) / 100;
  return {
    stake,
    total: stake * tips.length,
    count: tips.length,
    systemHandoff: {
      version: 1,
      preferences: { min: profile.systemMin, max: profile.systemMax },
      stakePerCombination: profile.combinationStake,
      totalLimit: Number.isFinite(cap) ? cap : null,
      selections: tips.map((t) => ({
        fixtureId: t.fixtureId,
        market: t.market,
        selection: t.selection,
        line: t.line,
        odd: t.marketOdd,
      })),
    },
  };
}

export function remainingStakeLimit(profile, confirmedTips = []) {
  const spent = confirmedTips
    .filter((t) => t.confirmed)
    .reduce((sum, t) => sum + (Number(t.stake) || 0), 0);
  return Math.max(
    0,
    Math.min(
      profile.maxStake ?? Infinity,
      (profile.budget ?? Infinity) - spent,
      (profile.maxTotalStake ?? Infinity) - spent
    )
  );
}
